module.exports = __webpack_public_path__ + "media/images/account/edit-img-b6091a820b942ca5cd15dd1974ee3f49.png";